module.exports = __webpack_public_path__ + "static/media/img7.3fc9debb.jpeg";